import { IconProps } from "./Icon.model";

export function LibraryIcon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color={fillColor}
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4802 1.77731C18.7242 1.58019 19.8369 2.47362 20.015 3.69585L22.2251 18.8597C22.4023 20.0758 21.6028 21.2596 20.367 21.4554L15.5193 22.2236C14.2753 22.4207 13.1626 21.5273 12.9845 20.305L10.7745 5.1412C10.5973 3.92513 11.3968 2.74128 12.6326 2.54546L17.4802 1.77731ZM16.5 18C16.5 17.4477 16.9477 17 17.5 17H17.509C18.0613 17 18.509 17.4477 18.509 18C18.509 18.5523 18.0613 19 17.509 19H17.5C16.9477 19 16.5 18.5523 16.5 18ZM18.3396 7.61859C18.7475 7.54658 19.0198 7.15754 18.9478 6.74963C18.8758 6.34172 18.4867 6.06942 18.0788 6.14143L13.2838 6.98788C12.8759 7.05988 12.6036 7.44893 12.6756 7.85684C12.7476 8.26474 13.1367 8.53705 13.5446 8.46504L18.3396 7.61859Z"
        fill={fillColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.75006 4.99999C1.75007 3.75735 2.75743 2.75 4.00006 2.75H9.00007C10.2427 2.75 11.2501 3.75736 11.2501 5V20C11.2501 21.2426 10.2427 22.25 9.00007 22.25H4C2.75736 22.25 1.74999 21.2426 1.75 20L1.75006 4.99999ZM5.5 18C5.5 17.4477 5.94772 17 6.5 17H6.50898C7.06126 17 7.50898 17.4477 7.50898 18C7.50898 18.5523 7.06126 19 6.50898 19H6.5C5.94772 19 5.5 18.5523 5.5 18ZM3.99219 6.75C3.57797 6.75 3.24219 7.08579 3.24219 7.5C3.24219 7.91421 3.57797 8.25 3.99219 8.25H9.00727C9.42148 8.25 9.75727 7.91421 9.75727 7.5C9.75727 7.08579 9.42148 6.75 9.00727 6.75H3.99219Z"
        fill={fillColor}
      />
    </svg>
  );
}
